import api from "PFCore/api";

export const sendContactMessage = (message: string) =>
  api({
    url: "contact_messages",
    method: "POST",
    data: {
      message
    }
  });
